export default "__VITE_ASSET__CrVrnKF___"